<template>
  <div class="container">
    <home-title
      title="图文资讯"
      link="https://lib.yiihuu.com/sc/"
      :icon="require('@/assets/images/home/home_title/icon10.svg')"
      :showMore="false"
    ></home-title>
    <div class="photo_box dfJcsb">
      <div class="photo_news">
        <div class="photo_top dfJsbAc">
          <span>图文教程</span>
          <a href="https://lib.yiihuu.com/twjc/" target="_blank">
            查看更多 <i class="el-icon-arrow-right"></i>
          </a>
        </div>
        <div class="photo_bottom">
          <div
            class="photo_item"
            v-for="e in photoList"
            :key="e.bookart_id"
            @click="goTwjc(e.bookart_id)"
          >
            <img :src="$homeSrc(e.bookart_img, 2)" alt="" />
            <div class="right">
              <p class="right_title toh">
                {{ e.bookart_name }}
              </p>
              <p class="right_info toh2" v-html="e.bookartext_cnt"></p>
              <div
                class="right_tag"
                v-for="item in e.skill_list"
                :key="item.btln_id"
              >
                {{ item.btln_name }}
              </div>
              <div class="right_bottom">
                <span class="people_num">{{ e.bookart_clicknum }}人浏览</span>
                <span>{{ e.bookart_time | timestampToTime }}</span>
              </div>
            </div>
          </div>

          <div class="cut ta3">
            <span @click="getList(0)">
              换一批 <i class="el-icon-refresh ta3"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="photo_news">
        <div class="photo_top dfJsbAc">
          <span>行业资讯</span>
          <a href="https://lib.yiihuu.com/news/" target="_blank">
            查看更多 <i class="el-icon-arrow-right"></i>
          </a>
        </div>
        <div class="photo_bottom">
          <div
            class="photo_item"
            v-for="e in newsList"
            :key="e.news_id"
            @click="goNews(e.news_id)"
          >
            <img :src="$homeSrc(e.news_image, 2)" alt="" />
            <div class="right">
              <p class="right_title toh">
                {{ e.news_name }}
              </p>
              <p class="right_info toh2" v-html="e.newsext_cnt"></p>
              <!-- <div class="right_tag">拍摄技巧</div> -->
              <div class="right_bottom">
                <span class="people_num">{{ e.news_readnum }}人浏览</span>
                <span>{{ e.news_time | timestampToTime }}</span>
              </div>
            </div>
          </div>
          <div class="cut ta3">
            <span @click="getList(1)">
              换一批 <i class="el-icon-refresh ta3"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeTitle from "./components/homeTitle";
import { getIndexOnTwzx } from "@/api/home";
export default {
  name: "photoNews",
  components: { homeTitle },
  data() {
    return {
      photoList: [],
      newsList: [],
      photoNum: 1,
      newsNum: 0,
    };
  },
  mounted() {
    this.getList(1);
  },
  methods: {
    getList(type) {
      if (type) {
        this.newsNum++;
      } else {
        this.photoNum++;
      }
      getIndexOnTwzx({ tw_page: this.photoNum, zx_page: this.newsNum }).then(
        (res) => {
          this.photoList = res.data.twjc.data;
          this.newsList = res.data.new.data;
        }
      );
    },
    goTwjc(id) {
      window.open(`https://lib.yiihuu.com/twjc/detail.php?id=${id}`);
    },
    goNews(id) {
      window.open(`https://lib.yiihuu.com/news/detail.php?id=${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 60px 0 44px;
  .photo_box {
    .photo_news {
      width: 678px;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
      &:first-child {
        .photo_top {
          background: url("@/assets/images/home/photo_bg1.png");
          span {
            text-shadow: 0px 0px 6px #00a589;
          }
          a {
            color: #1d7264;
          }
        }
      }
      &:last-child {
        .photo_top {
          background: url("@/assets/images/home/photo_bg2.png");
          span {
            text-shadow: 0px 0px 6px rgba(255, 127, 0, 0.5);
          }
          a {
            color: #a76200;
          }
        }
      }
    }
    .photo_top {
      width: 100%;
      height: 84px;
      padding: 0 20px;
      span {
        font-size: 18px;
        font-weight: bold;
        line-height: 21px;
        color: #fff;
      }
      a {
        font-size: 12px;
        line-height: 16px;
        &:hover {
          i {
            animation: arrowsSlide 0.3s;
          }
        }
      }
    }
    .photo_bottom {
      width: 100%;
      padding: 30px 20px;
      .photo_item {
        display: flex;
        width: 100%;
        cursor: pointer;
        margin-bottom: 24px;

        img {
          width: 186px;
          height: 128px;
          border-radius: 10px;
          margin-right: 18px;
          background: #cfcfcf;
        }
        .right {
          width: 434px;
          position: relative;
          .right_title {
            font-size: 16px;
            font-weight: 600;
            line-height: 21px;
            color: #333;
            margin-bottom: 7px;
          }
          .right_info {
            height: 42px;
            font-size: 12px;
            line-height: 21px;
            color: #999;
            margin-bottom: 4px;
          }
          .right_tag {
            display: inline-block;
            height: 28px;
            background: #f0f0f0;
            border-radius: 5px;
            font-size: 12px;
            color: #666;
            text-align: center;
            line-height: 28px;
            padding: 0 10px;
          }
          .right_bottom {
            font-size: 12px;
            line-height: 21px;
            color: #999;
            position: absolute;
            bottom: 0;
            left: 0;
            .people_num {
              margin-right: 27px;
            }
          }
        }
      }
      .cut {
        margin-top: 30px;
        text-align: center;
        font-size: 14px;
        line-height: 21px;
        color: #999;
        span {
          cursor: pointer;
          i {
            transform: rotateY(180deg);
          }
          &:hover {
            color: #22b79e;
            i {
              transform: rotateX(-180deg);
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1500px) and (min-width: 270px) {
  .container {
    .photo_box {
      .photo_news {
        width: 538px;
        .photo_top {
          width: 538px;
        }
        .photo_bottom {
          .photo_item {
            .right {
              width: 294px;
            }
          }
        }
      }
    }
  }
}
</style>
